import { Action, ActionCreator } from 'redux';

/**
 * ThreadActions specifies _action creators_ (i.e. objects that describe
 * changes to the reducers) that are concerned with Threads and Messages
 */

export const ADD_INSTRUMENTS = '[Instruments] Add Instruments';

export interface AddInstrumentAction extends Action {
  instruments: any;
}

export const addInstrument: ActionCreator<AddInstrumentAction> =
  (tabArgs: any): AddInstrumentAction => {
    const instruments: any = [...tabArgs];
    return {
      type: ADD_INSTRUMENTS,
      instruments: instruments
    };
  };



